import React, { useState, useEffect } from "react";
import { useForm } from "./FormContext";
import $ from "jquery";
import "jquery-validation";

const Contact = () => {
  const { openForm } = useForm();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    $("#contact-form").validate({
      rules: {
        name: {
          required: true,
          minlength: 2,
        },
        email: {
          required: true,
          email: true,
        },
        phone: {
          digits: true,
          minlength: 10,
          maxlength: 15,
        },
        message: {
          required: true,
          minlength: 10,
        },
      },
      messages: {
        name: {
          required: "Please enter your name",
          minlength: "Name must be at least 2 characters",
        },
        email: {
          required: "Please enter your email",
          email: "Please enter a valid email address",
        },
        phone: {
          digits: "Please enter valid phone number",
          minlength: "Phone must be at least 10 digits",
          maxlength: "Phone must not exceed 15 digits",
        },
        message: {
          required: "Please enter your message",
          minlength: "Message must be at least 10 characters",
        },
      },
      errorElement: "span",
      errorClass: "text-danger",
      errorPlacement: function (error, element) {
        error.insertAfter(element);
      },
    });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!$("#contact-form").valid()) {
      return;
    }

    setIsSubmitting(true);

    //  http://localhost/Anchor-point/php/submit_contact.php

    try {
      const response = await fetch("/php/submit_contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          form_type: "contact",
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert(result.message);
        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
        $("#contact-form")[0].reset();
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to send message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="animate contact">
      <div className="container">
        <div className="row justify-content-center mb-4 text-center">
          <div className="col-lg-10 conHead">
            <h2>Ready to Begin?</h2>
            <p>
              You don't have to navigate this alone. Reach out with your
              questions or send a message to explore if coaching is right for
              you.
            </p>
          </div>
        </div>
        <div className="row g-4 align-items-stretch">
          <div className="col-md-6 col-lg-5">
            <div className="ap-card h-100">
              <h3>Contact Details</h3>
              <p>
                <strong>Location:</strong>
                <br />
                Ace City Noida Extension Sector 1, Aimnabad, Bisrakh Jalalpur
                Greater Noida, Uttar Pradesh 201318
              </p>
              <p>
                <strong>Phone:</strong>
                <br />
                <a
                  href="tel:+919560659943"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  +91 95606 59943
                </a>
              </p>
              <p>
                <strong>Email:</strong>
                <br />
                <a
                  href="mailto:info@anchorpoints.in"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  info@anchorpoints.in
                </a>
              </p>
              <p>
                <strong>Coaching Modes:</strong>
                <br />
                Virtual · Hybrid ·Face-to-face (Delhi NCR)
              </p>
              <p>
                <strong>Hours:</strong>
                <br />
                Mon-Sat · 10:00 AM - 7:00 PM
              </p>
              <div className="mt-3">
                <button
                  type="button"
                  className="btn-new mt-3"
                  onClick={() =>
                    openForm({
                      service_title: "Free Discovery Call",
                      duration: "15 minutes",
                      format: "Online",
                    })
                  }
                  style={{ border: "none", cursor: "pointer" }}
                >
                  Book a Free Discovery Call
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-7">
            <div className="contact_map h-100">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.235561412615!2d77.45084565!3d28.56268835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ceeb815f53569%3A0x8bdcafbbc7aac2f5!2sNoida%20Extension%2C%20Ace%20City%20Noida%20Extension%2C%20Sector%201%2C%20Aimnabad%2C%20Bisrakh%20Jalalpur%2C%20Greater%20Noida%2C%20Bisrakh%20Jalalpur%2C%20Uttar%20Pradesh%20201318!5e0!3m2!1sen!2sin!4v1777961926722!5m2!1sen!2sin"
                width="100%"
                height="100%"
                title="Anchor Point Coaching Location"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                style={{ border: 0 }}
              ></iframe>
            </div>
            {/* <h3>Send a Message</h3>
              <form id="contact-form" onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-lg-6">
                    <label htmlFor="name" className="form-label">
                      Name*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="email" className="form-label">
                      Email*
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="phone" className="form-label">
                      Phone
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="subject" className="form-label">
                      Subject
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="subject"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-12">
                    <label htmlFor="message" className="form-label">
                      Message*
                    </label>
                    <textarea
                      className="form-control"
                      id="message"
                      name="message"
                      rows="4"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn-new mt-2"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Sending..." : "Send Message"}
                    </button>
                  </div>
                </div>
              </form> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
